export default "__VITE_ASSET__648b2ae3__"